export const homeFaqItems = [
  {
    id: 1,
    question: "自地自建需要多少預算？",
    answer:
      "預算主要受土地條件、建築規模、結構工法與室內裝修等級影響。以一般 50 坪 2 層住宅為例，傳統 RC 工法約 1,500–2,500 萬，預製鋼構工法約 2,000–3,500 萬。建議先透過我們的線上費用計算器試算，或直接加入 LINE 諮詢，提供基地位置與需求後，我們會給出更精準的預算級距建議。",
    icon: "ri-coins-line",
  },
  {
    id: 2,
    question: "沒有土地，也可以開始規劃自建嗎？",
    answer:
      "當然可以。許多業主都是在還沒有確定土地時，就開始了解預算、流程與選地條件。我們會協助你釐清建蔽率、容積率、地目限制等關鍵條件，讓你在選地時更有方向。建議先參加自地自建說明會，掌握完整流程後再開始找地。",
    icon: "ri-map-pin-line",
  },
  {
    id: 3,
    question: "自地自建從開始到入住，大約需要多久？",
    answer:
      "一般傳統工法從設計到完工約需 18–30 個月，其中設計 2–4 個月、報建審查 3–6 個月、施工 12–18 個月。若採用 Chronos 預製鋼構工法，施工期可縮短約 50%，最快 4 個月完成建築結構，整體時程可壓縮至 12–18 個月。實際時程依基地條件與規模而異。",
    icon: "ri-time-line",
  },
  {
    id: 4,
    question: "預製鋼構住宅安全嗎？能抗地震嗎？",
    answer:
      "預製鋼構工法在台灣已廣泛應用於商業建築與高端住宅，結構安全性經過完整計算與專業技師審核。鋼構具有良好的韌性與延展性，抗震表現優於傳統 RC 結構。Chronos 所有案件均由專業結構技師審核，並符合台灣建築技術規則與耐震設計規範。",
    icon: "ri-shield-check-line",
  },
  {
    id: 5,
    question: "可以只做建築設計，不包含施工嗎？",
    answer:
      "可以。Chronos 的設計與工程服務可分開規劃，也可以依業主既有合作團隊的條件進行配合。我們的建築設計、室內設計、營造施工均為獨立簽約，業主可依照自身需求選擇需要的服務項目。",
    icon: "ri-pencil-ruler-2-line",
  },
  {
    id: 6,
    question: "完工後如果有問題，有保固嗎？",
    answer:
      "有。我們提供結構體 1 年、防水工程 5 年、設備工程 1 年的保固服務。保固期間若發現任何施工品質問題，我們會安排專人前往檢視與處理。此外，我們也提供完工後的居住諮詢與維護建議，確保你的家長期維持最佳狀態。",
    icon: "ri-customer-service-2-line",
  },
];